import React from "react";
import { Alert, Button, Form, Input } from "antd";

export default function ManualInvoiceNumberField({ control, disabled = false }) {
  if (!control.visible) return null;
  return <Form.Item label="Numéro de facture (facultatif)" extra="Laissez vide pour la numérotation automatique. 20 caractères maximum, sans espace.">
    <Input aria-label="Numéro de facture manuel" value={control.value} maxLength={20} disabled={disabled}
      placeholder="Ex. CLIENT-2026-001" onChange={event => control.setValue(event.target.value)} />
    {control.resource.error && <Alert type="warning" showIcon message="Impossible d'actualiser la numérotation. Votre saisie est conservée."
      action={<Button size="small" onClick={() => void control.resource.refresh({ force: true }).catch(() => {})}>Réessayer</Button>} />}
    {control.value && control.resource.data && !control.resource.data.manual_allowed && <Alert type="error" showIcon
      message="La saisie manuelle a été désactivée. Votre numéro est conservé ; videz-le pour utiliser l'automatique." />}
    {control.value && !control.canAssign && <Alert type="error" showIcon message="La permission de saisie manuelle a changé. Votre numéro est conservé ; videz-le pour utiliser l'automatique." />}
  </Form.Item>;
}
